import React, { useEffect, useState } from 'react';
import Card from '../components/CardPhrases';
import data_allergies from './../data/phrases-allergies.json';
import data_authority from './../data/phrases-authority.json';
import data_bars from './../data/phrases-bars.json';
import data_basics from './../data/phrases-basics.json';
import data_bodyparts from './../data/phrases-bodyparts.json';
import data_clocktime from './../data/phrases-clocktime.json';
import data_colors from './../data/phrases-colors.json';
import data_commonsigns from './../data/phrases-commonsigns.json';
import data_counterwords from './../data/phrases-counterwords.json';
import data_days from './../data/phrases-days.json';
import data_daysofthemonth from './../data/phrases-daysofthemonth.json';
import data_daysoftheweek from './../data/phrases-daysoftheweek.json';
import data_directions from './../data/phrases-directions.json';
import data_driving from './../data/phrases-driving.json';
import data_duration from './../data/phrases-duration.json';
import data_eating from './../data/phrases-eating.json';
import data_explainingsymptoms from './../data/phrases-explainingsymptoms.json';
import data_extremeweather from './../data/phrases-extremeweather.json';
import data_family from './../data/phrases-family.json';
import data_lodging from './../data/phrases-lodging.json';
import data_medicalemergencies from './../data/phrases-medicalemergencies.json';
import data_money from './../data/phrases-money.json';
import data_months from './../data/phrases-months.json';
import data_numbers from './../data/phrases-numbers.json';
import data_offensivelanguage from './../data/phrases-offensivelanguage.json';
import data_onthephone from './../data/phrases-onthephone.json';
import data_problems from './../data/phrases-problems.json';
import data_seasons from './../data/phrases-seasons.json';
import data_shopping from './../data/phrases-shopping.json';
import data_time from './../data/phrases-time.json';
import data_transportation from './../data/phrases-transportation.json';
import data_typicaljapaneseexpressions from './../data/phrases-typicaljapaneseexpressions.json';
import BackToTopButton from '../components/BackToTopButton';

const Phrases = () => {

    const [type, setValue] = useState('');
    const handleTypeClick = (type) => {
        setValue(type);
    };

    const [showAll, setShowAll] = useState(undefined); // undefined = normal card behavior
    const [resetSignal, setResetSignal] = useState(0);
    const [pendingMap, setPendingMap] = useState({});

    const handleShowAll = () => {
        setShowAll(true);
    };

    const handleHideAll = () => {
        setShowAll(false);
    };

    const handleReset = () => {
        // 1. Clear override
        setShowAll(undefined);

        // 2. Remove all saved localStorage
        if (type === 'ALLERGIES') {
            data_allergies.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'AUTHORITY') {
            data_authority.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'BARS') {
            data_bars.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'BASICS') {
            data_basics.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'BODY PARTS') {
            data_bodyparts.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'CLOCK TIME') {
            data_clocktime.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'COLOURS') {
            data_colors.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'COMMON SIGNS') {
            data_commonsigns.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'COUNTER WORDS') {
            data_counterwords.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DAYS') {
            data_days.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DAYS OF THE MONTH') {
            data_daysofthemonth.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DAYS OF THE WEEK') {
            data_daysoftheweek.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DIRECTIONS') {
            data_directions.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DRIVING') {
            data_driving.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'DURATION') {
            data_duration.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'EATING') {
            data_eating.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'EXPLAINING SYMPTOMS') {
            data_explainingsymptoms.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'EXTREME WEATHER') {
            data_extremeweather.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'FAMILY') {
            data_family.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'LODGING') {
            data_lodging.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'MEDICAL EMERGENCIES') {
            data_medicalemergencies.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'MONEY') {
            data_money.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'MONTHS') {
            data_months.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'NUMBERS') {
            data_numbers.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'OFFENSIVE LANGUAGE') {
            data_offensivelanguage.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'ON THE PHONE') {
            data_onthephone.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'PROBLEMS') {
            data_problems.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'SEASONS') {
            data_seasons.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'SHOPPING') {
            data_shopping.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'TIME') {
            data_time.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else if (type === 'TRANSPORTATION') {
            data_transportation.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        } else {
            data_typicaljapaneseexpressions.forEach(k => {
                localStorage.removeItem(`phrases-${k.word}`);
            });
        }

        for (let key in localStorage) {
            if (key.startsWith("phrasesPending")) {
                localStorage.removeItem(key);
            }
        }

        // 3. Wait a tick to ensure showAll is undefined before resetting
        setTimeout(() => {
            setResetSignal(prev => prev + 1);
            setPendingMap({});
        }, 50);
    };

    useEffect(() => {
        const pending = JSON.parse(localStorage.getItem('phrasesPending') || '{}');
        setPendingMap(pending);
    }, []);

    const handleTogglePending = (kanji) => {
        setPendingMap((prev) => {
            const updated = { ...prev, [kanji]: !prev[kanji] };
            localStorage.setItem('phrasesPending', JSON.stringify(updated));
            return updated;
        });
    };

    return (
        <div className="px-6 pb-6 pt-6">
            <h1 className="text-4xl font-extrabold text-gray-800 mb-8 text-center">
                PHRASES {type}
            </h1>
            <div className="flex justify-center space-x-4 mb-4">
                <button
                    onClick={handleShowAll}
                    className="px-4 py-2 bg-green-400 text-white rounded hover:bg-green-500 active:scale-95 transition-transform"
                >
                    Show All Details
                </button>
                <button
                    onClick={handleHideAll}
                    className="px-4 py-2 bg-red-400 text-white rounded hover:bg-red-500 active:scale-95 transition-transform"
                >
                    Hide All Details
                </button>
                <button
                    onClick={handleReset}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 active:scale-95 transition-transform"
                >
                    Reset All
                </button>
            </div>
            <h3 className="text-gray-600 mb-8 text-center">
                Single tap - Play pronunciation<br />
                Double tap - Show / hide details<br />
                Long press - Mark / unmark for review
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 pb-8">
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('ALLERGIES')}>ALLERGIES</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('AUTHORITY')}>AUTHORITY</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('BARS')}>BARS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('BASICS')}>BASICS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('BODY PARTS')}>BODY PARTS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('CLOCK TIME')}>CLOCK TIME</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('COLOURS')}>COLOURS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('COMMON SIGNS')}>COMMON SIGNS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('COUNTER WORDS')}>COUNTER WORDS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DAYS')}>DAYS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DAYS OF THE MONTH')}>DAYS OF THE MONTH</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DAYS OF THE WEEK')}>DAYS OF THE WEEK</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DIRECTIONS')}>DIRECTIONS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DRIVING')}>DRIVING</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('DURATION')}>DURATION</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('EATING')}>EATING</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('EXPLAINING SYMPTOMS')}>EXPLAINING SYMPTOMS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('EXTREME WEATHER')}>EXTREME WEATHER</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('FAMILY')}>FAMILY</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('LODGING')}>LODGING</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('MEDICAL EMERGENCIES')}>MEDICAL EMERGENCIES</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('MONEY')}>MONEY</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('MONTHS')}>MONTHS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('NUMBERS')}>NUMBERS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('OFFENSIVE LANGUAGE')}>OFFENSIVE LANGUAGE</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('ON THE PHONE')}>ON THE PHONE</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('PROBLEMS')}>PROBLEMS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('SEASONS')}>SEASONS</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('SHOPPING')}>SHOPPING</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('TIME')}>TIME</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('TRANSPORTATION')}>TRANSPORTATION</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleTypeClick('TYPICAL JAPANESE EXPRESSIONS')}>TYPICAL JAPANESE EXPRESSIONS</button>
            </div>
            {type === 'ALLERGIES' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_allergies.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'AUTHORITY' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_authority.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'BARS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_bars.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'BASICS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_basics.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'BODY PARTS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_bodyparts.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'CLOCK TIME' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_clocktime.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'COLOURS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_colors.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'COMMON SIGNS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_commonsigns.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'COUNTER WORDS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_counterwords.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DAYS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_days.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DAYS OF THE MONTH' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_daysofthemonth.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DAYS OF THE WEEK' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_daysoftheweek.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DIRECTIONS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_directions.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DRIVING' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_driving.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'DURATION' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_duration.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'EATING' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_eating.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'EXPLAINING SYMPTOMS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_explainingsymptoms.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'EXTREME WEATHER' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_extremeweather.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'FAMILY' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_family.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'LODGING' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_lodging.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'MEDICAL EMERGENCIES' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_medicalemergencies.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'MONEY' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_money.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'MONTHS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_months.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'NUMBERS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_numbers.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'OFFENSIVE LANGUAGE' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_offensivelanguage.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'ON THE PHONE' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_onthephone.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'PROBLEMS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_problems.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'SEASONS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_seasons.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'SHOPPING' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_shopping.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'TIME' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_time.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'TRANSPORTATION' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_transportation.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {type === 'TYPICAL JAPANESE EXPRESSIONS' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data_typicaljapaneseexpressions.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            <BackToTopButton />
        </div>
    );
};

export default Phrases;